import { mapGetters } from 'vuex'
import TrackerDataTableItemTitle
from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemTitle/TrackerDataTableItemTitle.vue'

export default {
  name: 'TitlePageMobile',
  mixins: [TrackerDataTableItemTitle],
  props: {
    propDTO: Object,
    configuration: {
      type: Object
    },
    title: {
      type: String
    },
    subTitle: {
      type: String
    }
  },
  mounted () {
    if (this.propDTO && (this.mode !== 'edit' || this.mode !== 'insert')) {
      this.fetchParents()
    }
  },
  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerType: 'contextStore/trackerType',
      trackerTypes: 'contextStore/trackerTypes',
      mode: 'contextStore/contextMode',
      trackerId: 'contextStore/trackerId'
    }),
    titleClass () {
      return this.mode !== 'view' ? 'mt-n2 font-weight-regular title font-weight-bold' : 'mt-n2 font-weight-regular title'
    },
    titleStyle () {
      return this.mode !== 'view' ? { 'font-size': '25px !important' } : {}
    },
    computedTitleMobile () {
      if (this.title) {
        return this.title
      } else if (this.configuration?.itemTitle) {
        return this.$t(this.configuration.itemTitle, this.propDTO)
      } else if (this.propDTO) {
        const trackerTypeName = this.$t(this.trackerType?.name) + ' ' + this.propDTO?.id
        return trackerTypeName ?? ''
      } else {
        return ''
      }
    },

    computedSubTitleMobile () {
      if (this.subTitle) {
        return this.subTitle
      } else {
        if (this.configuration?.itemSubtitle) {
          return this.$t(this.configuration.itemSubtitle, this.propDTO)
        } else {
          return this.propDTO?.title ?? ''
        }
      }
    }
  }
}
